// Vocab de presentación del banco de embriones (api-reference/admin-embryos.md).
// El estadio (stage), la preservación (storage) y sus chips viven en clivage.js /
// transfers.js (paleta canónica, lookup case-insensitive). Acá solo el ORIGEN
// (source: opu|external) y el ESTADO (status), propios de este recurso.

export const EMBRYO_SOURCE = [
    { value: 'opu', label: 'OPU' },
    { value: 'external', label: 'Externo' },
];
const SOURCE_LABEL = Object.fromEntries(EMBRYO_SOURCE.map((s) => [s.value, s.label]));
export const embryoSourceLabel = (s) => SOURCE_LABEL[s] || '—';

// status (soft-delete lifecycle del backend): 2 activo · 1 inactivo · 0 eliminado.
export const EMBRYO_STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };
